import type { FlowImportMapping, PortableFlowPackage } from './types';

type PendingFlowImport = {
	flow: PortableFlowPackage;
	mapping: FlowImportMapping;
};

let pendingImport: PendingFlowImport | null = null;

/** In-memory handoff from the Flow list import modal to the new-Flow editor route. */
export function setPendingFlowImport(value: PendingFlowImport): void {
	pendingImport = value;
}

export function takePendingFlowImport(): PendingFlowImport | null {
	const value = pendingImport;
	pendingImport = null;
	return value;
}
